import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Chat from './App';
import Chad from './chadgpt';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
 <Chad/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
